


















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({
  components: {},
})
export default class DropdownOptions extends Vue {
  @Prop({ default: false }) disabled!: boolean;
  private mostrar: boolean = false;
  close() {
    this.mostrar = false;
  }
}
